<template>
    <div class="tabs">
        <div class="wrapper_header_sidebar">
            <div class="header_sidebar_wrpr">
                <a @click="linkTo(null)" class="small-btn back_btn">
	                <inline-svg :src="require('@/assets/icons/back.svg')" />
                </a>
                <h4 class="title_sidebar">Settings</h4>
            </div>
        </div>
        <div id="tabs-content">
            <div class="tab-content page-settings">
	            <div class="seo-preview">
		            <span class="seo-title">{{seoSettings.seo_title || ''}}</span>
		            <span class="seo-url">{{'https://'+url}}</span>
		            <span class="seo-desc">{{seoSettings.seo_description || ''}}</span>
	            </div>

	            <input-field class="margin-t-25" v-model="seoSettings.seo_title" label="Title" @input="dataUpdated" />

	            <input-field class="margin-t-25" rows="4" textarea v-model="seoSettings.seo_description" label="Description" @input="dataUpdated" />

	            <!--                <TextInput :value="seoSettings.seo_title || ''" title="Title" @updated="dataUpdated('seo_title', $event)"/>-->
<!--                <TextInput textarea rows="3" :value="seoSettings.seo_description || ''"-->
<!--                           title="Description" @updated="dataUpdated('seo_description', $event)"/>-->
            </div>
        </div>
    </div>
</template>

<script>
import InputField from "@/components/base/input-field"
import MultiSelectItem from "@/modules/page-editor/src/components/sidebar/sidebar-items/MultiSelectItem.vue"
import debounceAction from "@/helpers/debounce"
import VButton from "@/components/base/v-button"

import {mapGetters} from "vuex";
export default {
    name: 'Settings',
    components: {
    	VButton,
      InputField,
      MultiSelectItem
    },
    data() {
        return {
            localData: {
                seo_description: '',
                seo_keywords: '',
                seo_title: '',
            }
        }
    },
    computed: {
    	...mapGetters(['current_template']),
        seoSettings() {
            return this.localData;
        },
	    url() {
		    return this.current_template ? this.current_template.url : "";
	    }
    },
    methods: {
        linkTo(tab) {
            this.$store.commit('PAGE_SET_TAB', tab)
        },
        dataUpdated: debounceAction(function(){
            // let testObj = {...this.localData};
            // testObj[infoName] = value;
            this.$store.dispatch('PAGE_SETTINGS_UPDATE', this.localData);
        }, 100),
    },
	mounted() {
    	try {
		    this.localData.seo_keywords = '';
		    this.localData.seo_description = this.$store.state.page.currentTemplate.seo_description || ''
		    this.localData.seo_title = this.$store.state.page.currentTemplate.seo_title || ''
	    } catch (e) {
		    console.warn(e)
	    }
	},
	created(){

    }
}
</script>
<style lang="scss">
.page-settings {
	padding: 10px;
	//display: flex;
	//flex-direction: column;

	.item_sidebar.description .input-field {
		height: auto;
	}
}
</style>
<style lang="scss" scoped>

.seo-preview {
	border: 1px solid #e3e6f1;
	border-radius: 5px;
	padding: 10px;
	margin: 10px;
	flex-direction: column;
	display: flex;
	overflow: hidden;

	.title {
		font-size: 16px;
		color: $grey;
		font-weight: 600;
		line-height: 20px;
	}
	.seo-title {
		color: #1a0dab;
		font-size: 17px;
		line-height: 26px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
	.seo-url {
		line-height: 24px;
		font-size: 12px;
		color: #006621;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
	.seo-desc {
		line-height: 17px;
		word-wrap: break-word;
		color: #545454;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}
}
</style>
